






























import { Component, Vue, Emit, Prop } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import SolicitacaoCancelamentoStore from '@/components/SolicitacaoCancelamento/Store/SolicitacaoCancelamentoStore'
import { TipoOrigemEnum, RequestMessage, TipoUsuarioEnum, Solicitacao } from '@/types/_'
import { timeoutDefault } from '@/utils/common'
import EventBus from '@/plugins/EventBus'
import SolicitacaoClinicaStore from '../SolicitacaoCirurgia/store/SolicitacaoClinicaStore'
import SolicitacaoPendenciaStore from '../SolicitacaoPendencia/Store/SolicitacaoPendenciaStore'

@Component

export default class ModalSolicitacaoCancelamentoMedico extends Vue {
  @Prop({ required: true }) tipoUsuario: TipoUsuarioEnum
  @Prop({ required: false, default: false }) podeSolicitarCancelamento: boolean
  @Prop({ required: false, default: false }) clinicaFazCancelamentoDaSolicitacao: boolean
  @Prop({ required: false, default: false }) medicoCancelaSolicitacao: boolean
  @Prop({ required: false, default: '' }) subtitle: boolean

  loadCancelar: boolean = false
  loadVoltar: boolean = false

  get loadingCancelar() {
    return this.loadCancelar
  }

  set loadingCancelar(val: boolean) {
    this.loadCancelar = val
  }

  get loadingVoltar() {
    return this.loadVoltar
  }

  set loadingVoltar(val: boolean) {
    this.loadVoltar = val
  }

  get getSolicitacaoCancelamentoStore() {
    return getModule(SolicitacaoCancelamentoStore, this.$store)
  }

  get solicitacaoClinicaStore() {
    return getModule(SolicitacaoClinicaStore, this.$store)
  }

  get getSolicitacaoPendenciaStore() {
    return getModule(SolicitacaoPendenciaStore, this.$store)
  }

  get showModal() {
    return this.getSolicitacaoCancelamentoStore.modal.cancelamentoMedico
  }

  set showModal(value: boolean) {
    this.getSolicitacaoCancelamentoStore.setShowModalCancelamentoMedico(value)
  }

  async cancelamentoSolicitado(origem: TipoOrigemEnum) {
    const solicitacaoId = this.getSolicitacaoPendenciaStore.agendamentoMedico.id

    if (this.isValid()) {
      this.loadingCancelar = true

      let response: any

      if (this.medicoCancelaSolicitacao) {
        response = await this.getSolicitacaoCancelamentoStore.deactivateSurgerySolicitation({
          notes: this.getSolicitacaoCancelamentoStore.observacaoDoCancelamento,
          deactivationReason: this.getSolicitacaoCancelamentoStore.motivo,
          surgerySolicitationId: solicitacaoId,
        })
      } else if (this.podeSolicitarCancelamento) {
        response = await this.getSolicitacaoCancelamentoStore.cancelarSolicitacaoMedico(this.getSolicitacaoCancelamentoStore.motivo)
      } else if (this.clinicaFazCancelamentoDaSolicitacao) {
        response = await this.solicitacaoClinicaStore.cancelar({
          solicitacaoId,
          data: {
            motivoCancelamentoId: this.getSolicitacaoCancelamentoStore.motivo,
          },
        })
      }

      if (response.success) {
        EventBus.$emit('setSnackbar', { show: true, text: 'Ação realizada com sucesso.', icon: 'done', color: '#2E7D32' })

        this.closeModal(response.data.solicitacao)
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Houve um problema no cancelamento da solicitação.', icon: 'warning', color: '#C62828' })
      }

      this.loadingCancelar = false
    }
  }

  isValid() {
    let valid: boolean = true
    if (['', null, undefined].includes(this.getSolicitacaoCancelamentoStore.motivo)) {
      valid = false
      this.getSolicitacaoCancelamentoStore.setMotivoMessage('Por favor informe o motivo.')
    } else {
      this.getSolicitacaoCancelamentoStore.setMotivoMessage('')
    }

    return valid
  }

  async voltar() {
    this.loadingVoltar = true
    await timeoutDefault()
    this.getSolicitacaoCancelamentoStore.setShowModalCancelamentoMedico(false)
    this.getSolicitacaoCancelamentoStore.clear()
    this.loadingVoltar = false
  }

  @Emit('setLoadingRequest')
  setLoadingRequest(status, text) { }

  @Emit('clearLoadingRequest')
  clearLoadingRequest() { }

  @Emit('closeModal')
  closeModal(solicitacao: Solicitacao) {
    this.getSolicitacaoCancelamentoStore.setShowModalCancelamentoMedico(false)
    this.getSolicitacaoCancelamentoStore.clear()
    return solicitacao
  }
}

